/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_ActionInputs */



/**
* | output |
* | --- |
* | "ACTION" |
*
* @param {Ccsl_Export_Header_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_action = /** @type {((inputs?: Ccsl_Export_Header_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ACTION")
	if (locale === "de") return /** @type {LocalizedString} */ ("AKTION")
	if (locale === "it") return /** @type {LocalizedString} */ ("AZIONE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ДЕЙСТВИЕ")
	if (locale === "es") return /** @type {LocalizedString} */ ("ACCIÓN")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्रवाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AÇÃO")
	return /** @type {LocalizedString} */ ("ACTION")
});